/**
 * @module Components.DiscountedPrice
 *
 * Discounted price with the original struck through beside it — e.g.
 * "$975 $1,300 per year". Used by the checkout PriceCards' PURCHASE mode, where
 * the title carries the price (no trial "days free" lead-in) and the discount
 * would otherwise be invisible on the card. The discounted amount inherits the
 * surrounding title styling; the original is rendered smaller and struck through.
 */
import React from "react";
import { Trans } from "react-i18next";
import { Currency, formatPrice } from "app/utils/currency";
import styles from "./styles.module.scss";

type PropsDef = {
  // Cents.
  discounted: number;
  original: number;
  currency: Currency;
  // Billing period word, already localized ("year" / "month").
  interval: string;
};

const DiscountedPrice = ({ discounted, original, currency, interval }: PropsDef) => (
  <Trans
    i18nKey="purchase_price_discounted"
    values={{
      original: formatPrice(original, currency),
      discounted: formatPrice(discounted, currency),
      interval,
    }}
    components={{
      original: <span className={styles.original} />,
      discounted: <span className={styles.discounted} />,
    }}
  />
);

export default DiscountedPrice;
